<template>
  <div class="addOrg">
    <div class="title">
      组织结构 <span>{{org.title}}</span>
    </div>
    <div class="main">
      <div class="addEmailInfo">{{org.title}}</div>
      <div class="orgContent">
        <div class="orglist">
          <label for="orgname">
            <span>*</span>{{org.name}}
          </label>
          <el-input size="small"
                    placeholder="请输入公司名称"
                    v-model="orgInfo.name"></el-input>
        </div>
        <div class="orglist">
          <label for="orgnum">
            <span>*</span>编码
          </label>
          <el-input size="small"
                    v-model="orgInfo.encoding"></el-input>
        </div>
        <div class="orglist">
          <label for="remark">备注</label>
          <el-input type="textarea"
                    :autosize="{ minRows: 3, maxRows: 8}"
                    v-model="orgInfo.remark"></el-input>
        </div>
        <div class="orgBtn">
          <button class="save"
                  @click="handleAddEmailClick">
            保存
          </button>
          <button @click="handleCancelClick"
                  class="cancel">
            取消
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addOrganization, getChangeOrg, updateOrganization } from 'apis/index'
export default {
  name: 'addOrg',
  data () {
    return {
      id: '',
      companyID: '',
      orgInfo: {
        name: '',
        encoding: '',
        remark: '',
        type: 0
      },
      org: {
        title: '添加组织结构',
        name: '公司名称'
      }
    }
  },
  methods: {
    handleAddEmailClick () { // 添加/修改组织结构
      if (this.companyID) {
        addOrganization({ // 添加子结构
          parentId: this.companyID,
          name: this.orgInfo.name,
          encoding: this.orgInfo.encoding,
          remark: this.orgInfo.remark,
          type: this.orgInfo.type
        }).then(res => {
          if (res.data.code === 200) {
            this.$router.push({ path: '/system/organiz' })
          }
        })
      } else {
        if (this.id) {
          if (this.orgInfo.type === 0) {
            // console.log('修改公司结构')

            updateOrganization({ // 修改公司结构
              id: this.id,
              name: this.orgInfo.name,
              encoding: this.orgInfo.encoding,
              remark: this.orgInfo.remark,
              type: this.orgInfo.type
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/system/organiz' })
              }
            })
          } else if (this.orgInfo.type === 1) {
            updateOrganization({ // 修改子结构
              parentId: this.orgInfo.parentId,
              id: this.id,
              name: this.orgInfo.name,
              encoding: this.orgInfo.encoding,
              remark: this.orgInfo.remark,
              type: this.orgInfo.type
            }).then(res => {
              if (res.data.code === 200) {
                this.$router.push({ path: '/system/organiz' })
              }
            })
          }
        } else {
          addOrganization({ // 添加公司
            name: this.orgInfo.name,
            encoding: this.orgInfo.encoding,
            remark: this.orgInfo.remark,
            type: this.orgInfo.type
          }).then(res => {
            if (res.data.code === 200) {
              this.$router.push({ path: '/system/organiz' })
            }
          })
        }
      }
    },
    getData (id) { // 修改初始化
      getChangeOrg({
        id: id
      }).then(res => {
        if (res.data.code === 200) {
          this.orgInfo = res.data.data
          if (this.orgInfo.type === 0) {
            this.org = {
              title: '修改组织结构',
              name: '公司名称'
            }
          } else if (this.orgInfo.type === 1) {
            this.org = {
              title: '修改子结构',
              name: '部门名称'
            }
          }
        }
      })
    },
    handleCancelClick () { // 取消添加/修改
      this.$router.push({ path: '/system/organiz' })
    }
  },
  mounted () {
    if (this.$route.query.company) {
      this.id = this.$route.query.company
      this.getData(this.id)
    }
    if (this.$route.query.add) {
      this.companyID = this.$route.query.add
      this.orgInfo.type = 1
      this.org = {
        title: '添加子结构',
        name: '部门名称'
      }
    }
  }
}
</script>
<style lang="stylus">
.addOrg
  position absolute
  top 0px
  bottom 20px
  left 20px
  right 20px
  z-index 1
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 57px #F7F9FB
    span
      color #212832
      margin-left 20px
  .main
    width 100%
    background #fff
    height calc(100% - 50px)
    .addEmailInfo
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../assets/images/03/add_icon.png') no-repeat center left 15px
    .orgContent
      width 100%
      height calc(100% - 62px)
      padding-top 14px
      border-top 1px solid #CFD5DC
      border-bottom 1px solid #CFD5DC
      .orglist
        margin-top 26px
        label
          width 154px
          float left
          line-height 32px
          text-align right
          font-size 12px
          color #5E656F
          span
            color #FF344A
        .el-input
          width 220px
          margin-left 12px
        .el-textarea
          width 475px
          margin-left 12px
      .orgBtn
        margin-left 153px
        margin-top 94px
        button
          padding 4px 26px
          cursor pointer
          margin 0 20px
          background #FFFFFF
          border-radius 3px
          border 1px solid #CFD5DC
          &:hover
            background #1B88EE
            color #fff
            border 1px solid #1B88EE
</style>
